import React, { useState } from 'react';
import { createPortal } from 'react-dom';

type CampaignType = {
    id: string;
    label: string;
};

interface CampaignTypeModalProps {
    isOpen: boolean;
    selectedTypesProp?: string[];
    onClose: () => void;
    onApply: (selected: string[]) => void;
}

const campaignTypes: CampaignType[] = [
    { id: 'SP_AUTO', label: 'Sponsored Products - Auto Targeting' },
    { id: 'SP_KEYWORD', label: 'Sponsored Products - Keyword Targeting' },
    { id: 'SP_PRODUCT', label: 'Sponsored Products - Product Targeting' },
    { id: 'SB_KEYWORD', label: 'Sponsored Brands - Keyword Targeting' },
    { id: 'SB_PRODUCT', label: 'Sponsored Brands - Product Targeting' },
    { id: 'SBV_KEYWORD', label: 'Sponsored Brands - Video - Keyword Targeting' },
    { id: 'SBV_PRODUCT', label: 'Sponsored Brands - Video - Product Targeting' },
    { id: 'SD_AUDIENCE', label: 'Sponsored Display - Audiences' },
    { id: 'SD_PRODUCT', label: 'Sponsored Display - Product Targeting' },
    { id: 'STV', label: 'Sponsored TV' },
];

export const CampaignTypeModal: React.FC<CampaignTypeModalProps> = ({
    isOpen,
    onClose,
    onApply,
    selectedTypesProp = [],
}) => {
    const [selectedTypes, setSelectedTypes] = useState<string[]>(selectedTypesProp);

    const toggleType = (id: string) => {
        setSelectedTypes((prev) =>
            prev.includes(id) ? prev.filter((t) => t !== id) : [...prev, id]
        );
    };

    const handleApply = () => {
        onApply(selectedTypes);
        onClose();
    };

    if (!isOpen) return null;

    return createPortal(
        <div className="modal fade show d-block" tabIndex={-1} role="dialog">
            <div className="modal-backdrop fade show" onClick={onClose}></div>
            <div className="modal-dialog modal-dialog-centered" role="document" style={{ zIndex: 1050 }}>
                <div className="modal-content shadow">
                    <div className="modal-header">
                        <h5 className="modal-title">Campaign Type</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        {campaignTypes.map((type) => (
                            <div className="form-check" key={type.id}>
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={type.id}
                                    checked={selectedTypes.includes(type.id)}
                                    onChange={() => toggleType(type.id)}
                                />
                                <label className="form-check-label" htmlFor={type.id}>
                                    {type.label}
                                </label>
                            </div>
                        ))}
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-outline-secondary" onClick={onClose}>
                            Cancel
                        </button>
                        <button style={{ height: "38px" }} className="btn btn-primary" onClick={handleApply}>
                            Apply
                        </button>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};
